document.addEventListener("DOMContentLoaded", () => {
  const productList = document.querySelectorAll(".product-list-slider");

  productList.forEach(list => {
    const slider = new Splide(list, {
      type: 'slide',
      rewind: true,
      pagination: true,
      arrows: true,
      perPage: 4,
      gap: 16,
      trimSpace: false,
      breakpoints: { 1024: { perPage: 2, gap: 16 }, 767: { perPage: 1, gap: 16, padding: { right: '4rem' } } }
    });

    slider.mount();
  });
});